export default __webpack_public_path__ + "static/media/appstore.ef826103.svg";